import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@app/services/settings.service';

@Component({
  selector: 'app-personalize-dialog',
  templateUrl: './personalize-dialog.component.html',
  styleUrls: ['./personalize-dialog.component.scss'],
})
export class PersonalizeDialogComponent implements OnInit {
  constructor(private settings: SettingsService) {}

  ngOnInit(): void {}
}
